/**
 * "EN (automatic translation, for info only)" onder een niet-Engelse Mass Message-tekst (24-10-2026, Jordy).
 * Niets als de tekst al Engels is. De verzonden tekst blijft de oorspronkelijke.
 */
import { useEffect, useState } from 'react'
import { useEngels } from '../lib/mmEngels'

export function EnRegel({ tekst, afkappen = false, wacht = 0 }: {
  tekst: string | null | undefined
  /** Eén regel (lijsten); anders de hele vertaling. */
  afkappen?: boolean
  /** Bij typen (Create/Edit): pas vragen als de tekst zo lang (ms) stil staat. */
  wacht?: number
}) {
  const [stil, setStil] = useState(tekst ?? '')
  useEffect(() => {
    if (!wacht) { setStil(tekst ?? ''); return }
    const t = window.setTimeout(() => setStil(tekst ?? ''), wacht)
    return () => window.clearTimeout(t)
  }, [tekst, wacht])
  const u = useEngels(stil)
  if (!u || u.status === 'english') return null
  return (
    <div className={afkappen ? 'en-regel afkap' : 'en-regel'} data-testid="en-regel" title={u.en ?? undefined}>
      <span className="en-label">EN (automatic translation, for info only):</span>{' '}
      {u.status === 'translated' ? u.en
        : u.status === 'pending' ? <span className="dim">translating…</span>
          : <span className="dim">translation not available</span>}
    </div>
  )
}
